// src/components/mobile/TicketLineMobile.jsx
import React, { useContext } from "react";
import { Box, Typography, Chip, Avatar } from "@mui/material";
import { LanguageContext } from "../../context/LanguageContext";
import { statusColors } from "../../constants/statusColors";

export default function TicketLineMobile({ ticket, creator, onEdit, canEdit }) {
  const { translate } = useContext(LanguageContext);
  const statusBg = statusColors[ticket.status] || "#ccc";

  return (
    <Box
      //   onClick={() => canEdit && onEdit(ticket)}
      onClick={() => onEdit(ticket)}
      sx={{
        p: 1,
        mb: 1,
        borderRadius: 1,
        bgcolor: canEdit ? "background.paper" : "grey.100",
        boxShadow: 1,
        cursor: canEdit ? "pointer" : "default",
      }}
    >
      {/* Ligne principale : avatar + n° + titre */}
      <Box display="flex" alignItems="center" mb={0.5}>
        <Avatar src={creator.photoUrl} sx={{ width: 24, height: 24, mr: 1 }} />
        <Typography variant="body2" noWrap sx={{ flex: 1, fontWeight: 500 }}>
          {ticket.ticketNumber} — {ticket.ticketName}
        </Typography>
      </Box>

      {/* Priorité & Statut */}
      <Box display="flex" justifyContent="space-between">
        <Chip
          label={translate(ticket.priority)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
        <Chip
          label={translate(ticket.status)}
          size="small"
          sx={{
            bgcolor: statusBg,
            color: "#fff",
            textTransform: "capitalize",
          }}
        />
      </Box>
    </Box>
  );
}
